module.exports = __webpack_public_path__ + "area_chuanyu.645f1501.png";